t = require('views/internal/teacup-with-helpers')('menu_base')

module.exports = ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.ul '.boards-pop-over-list'
    t.raw t.mustacheVar('content')



// WEBPACK FOOTER //
// ./app/scripts/views/templates/menu_base.coffee